<!--
  - Copyright (c) 2022 by 安徽网才信息技术股份有限公司
  -
  - 除非事先获得版权所有人的许可, 禁止以下几项行为:
  - 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
  - 2. 向第三方透露任何与该软件相关的源代码或技术文档。
  - 3. 更改或删除软件或源码中的版权声明。
  -
  -->

<template>
    <div>
        <header>
            <div class="m-content header">
                <div class="m-box clearfix font13">
                    <div class="fl">
                        <div id="js_mobile_pop" class="fl relative">
                            <a href="https://www.goodjobs.cn/app.html" target="_blank" class="white"><i class="mr-4 icw icw-phone"></i>手机求职</a>
                            <div id="js_mobile_pop_child" class="codebox" style="display:none; z-index:10;">
                                <div class="triangle" style="margin-left:27px;"></div>
                                <div class="clearfix">
                                    <ul class="pl-10 pr-10">
                                        <li class="fl wp33 center">
                                            APP<br />
                                            <img src="https://cdn.ahjob.com.cn/www/images/app_128.png?v=20200814" width="120" />
                                        </li>
                                        <li class="fl wp33 center">
                                            微信小程序<br />
                                            <img style="margin-top:-5px;" src="https://cdn.ahjob.com.cn/www/images/wx_mp.jpg" height="150" />
                                        </li>
                                        <li class="fl wp33 center">
                                            官方微信<br />
                                            <img src="https://cdn.ahjob.com.cn/www/images/weixin_128.gif" width="120" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="fl relative cityJob">
                            <div class="white pl-20">
                                <i class="mr-4 icw icw-city"></i>城市求职
                            </div>
                            <div class="citybox topCitySelect" style="z-index:10;">
                                <div class="triangle" style="margin-left:27px;"></div>
                                <div class="clearfix">
                                    <ul class="citylist">
                                        <li><a href="https://hefei.goodjobs.cn/" target="_blank">合肥</a></li>
                                        <li><a href="https://wuhu.goodjobs.cn/" target="_blank">芜湖</a></li>
                                        <li><a href="https://bengbu.goodjobs.cn/" target="_blank">蚌埠</a></li>
                                        <li><a href="https://maanshan.goodjobs.cn/" target="_blank">马鞍山</a></li>
                                        <li><a href="https://anqing.goodjobs.cn/" target="_blank">安庆</a></li>
                                        <li><a href="https://chaohu.goodjobs.cn/" target="_blank">巢湖</a></li>
                                        <li><a href="https://liuan.goodjobs.cn/" target="_blank">六安</a></li>
                                        <li><a href="https://suzhou.goodjobs.cn/" target="_blank">宿州</a></li>
                                        <li><a href="https://fuyang.goodjobs.cn/" target="_blank">阜阳</a></li>
                                        <li><a href="https://huainan.goodjobs.cn/" target="_blank">淮南</a></li>
                                        <li><a href="https://chuzhou.goodjobs.cn/" target="_blank">滁州</a></li>
                                        <li><a href="https://huaibei.goodjobs.cn/" target="_blank">淮北</a></li>
                                        <li><a href="https://bozhou.goodjobs.cn/" target="_blank">亳州</a></li>
                                        <li><a href="https://tongling.goodjobs.cn/" target="_blank">铜陵</a></li>
                                        <li><a href="https://xuancheng.goodjobs.cn/" target="_blank">宣城</a></li>
                                        <li><a href="https://chizhou.goodjobs.cn/" target="_blank">池州</a></li>
                                        <li style="margin-right: 100px;">
                                            <a href="https://huangshan.goodjobs.cn/" target="_blank">黄山</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fr white">
                        <div class="relative fl person-info">
                            <router-link v-if="!$store.getters['hasLogin']" :to="{name: 'login'}" class="mr-10 white">
                                登录
                            </router-link>
                            <el-dropdown v-if="$store.getters['hasLogin']" class="logout" @command="handleCommand">
                                <span class="el-dropdown-link white">
                                    hi, {{ $store.state.userInfo.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-if="!$store.state.userInfo.setPassword" command="password">
                                        设置密码
                                    </el-dropdown-item>
                                    <el-dropdown-item v-else command="modifyPassword">
                                        修改密码
                                    </el-dropdown-item>
                                    <el-dropdown-item command="feedback">
                                        我的反馈
                                    </el-dropdown-item>
                                    <el-dropdown-item command="logout">
                                        退出
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <!--<a class="white" href="https://user.goodjobs.cn/index.php/action/Register">注册</a>-->
                        </div>
                        <span class="pad-lr-10">|</span>
                        <a href="https://ehr.goodjobs.cn/" class="white" target="_blank">企业服务</a>
                    </div>
                </div>
            </div>
        </header>
        <section class="m-nav">
            <section class="clearfix dcenter w1080">
                <figure class="fl logo mr-10" style="margin-top:22px;">
                    <a href="https://www.goodjobs.cn">
                        <img :src="logo" width="140" height="46" alt="" />
                    </a>
                </figure>
                <figure class="fl logo border-l pl-10 mt-36">
                    <img src="@/assets/images/r_logo.svg" width="106" height="26" alt="" />
                </figure>
                <nav class="menu">
                    <router-link :to="{name: 'notice'}" active-class="on">
                        考试公告
                    </router-link>
                    <router-link :to="{name: 'project'}" active-class="on">
                        网上报名
                    </router-link>
                    <router-link :to="{name: 'my'}" active-class="on">
                        我的报考
                    </router-link>
                </nav>
            </section>
        </section>
        <div class="m-banner2" :style="{background:'url(' + bgPic + ') no-repeat center center'}" :class="className">
        </div>
        <!--   设置密码     -->
        <el-dialog title="设置密码" :visible.sync="dialogFormVisible" width="600px">
            <el-form ref="ruleForm" :model="form" status-icon :rules="rules">
                <el-form-item label="登录密码" :label-width="formLabelWidth" prop="password">
                    <el-input v-model="form.password" type="password" autocomplete="off" placeholder="6-20位字母、数字、符号组合" />
                </el-form-item>
                <el-form-item label="确认密码" :label-width="formLabelWidth" prop="confirmPassword">
                    <el-input v-model="form.confirmPassword" type="password" autocomplete="off" placeholder="确认密码" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">
                    取 消
                </el-button>
                <el-button type="primary" @click="setPassword">
                    确 定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { setPassword } from '@/api/user';

export default {
    name: 'XaLayoutHeader',
    props: {
        className: {
            type: String,
            default: ''
        }
    },
    data() {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.form.confirmPassword !== '') {
                    this.$refs.ruleForm.validateField('confirmPassword');
                }
                callback();
            }
        };
        const validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            logo: require('@/assets/images/r_wlogo.svg'),
            bgPic: require('@/assets/images/dl_bg.png'),
            form: {
                password: '',
                confirmPassword: ''
            },
            dialogFormVisible: false,
            formLabelWidth: '120px',
            rules: {
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                confirmPassword: [
                    { validator: validatePass2, trigger: 'blur' }
                ]
            }
        };
    },
    watch: {
        '$store.state.meta': {
            handler: function(newVal) {
                this.logo  = newVal.logo;
                this.bgPic = newVal.bgPic;
            }
        }
    },
    created() {
        this.$store.dispatch('getUserInfo');
    },
    methods: {
        handleCommand(command) {
            if (command === 'logout') {
                this.$store.dispatch('handleLogout');
                this.$message.success('退出成功');

                setTimeout(() => {
                    this.$router.replace({name: 'home'});
                    /*if (['user-center', 'user-set', 'apply'].includes(this.$route.name)) {
                        this.$router.replace({name: 'login'});
                    }*/
                }, 2000);
            } else if (command === 'password') {
                this.showSetPassword();
            } else if (command === 'modifyPassword') {
                this.$router.push({
                    name: 'change-password'
                });
            } else if (command === 'feedback') {
                this.$router.push({
                    name: 'feedback'
                });
            }
        },
        showSetPassword() {
            this.dialogFormVisible = true;
            this.form.password = '';
            this.form.confirmPassword = '';
        },
        // 设置密码
        setPassword() {
            this.$refs['ruleForm'].validate(async(valid) => {
                if (valid) {
                    await setPassword({password: this.form.password});
                    this.$message.success('设置成功');
                    this.dialogFormVisible = false;
                    await this.$store.dispatch('getUserInfo');
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
@import '@/styles/exam_header.css';
.m-box{
    margin-top: 0;
}
.cityJob:hover .citybox{
    display: block;
}
.citybox{
    display: none;
}
.hide{
    display: none;
}
</style>
